<template>
  <div
    class="headerIcon"
    :class="{ warning: profileAccessTierOrder <= 10 && props.warning }"
  >
    <div
      class="innerIcon"
      :class="{active}"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 20V19.25C20 16.9028 18.0972 15 15.75 15H8.25C5.90279 15 4 16.9028 4 19.25V20" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="7" r="4" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import store from "@/store/store.js";

const profileAccessTierOrder = computed(() => store.getters["user/profileAccessTierOrder"])

const props = defineProps({
  color: {
    type: String,
    default: '#ffffff' // #8B8B8B
  },
  active: {
    type: Boolean,
    default: false,
  },
  warning: {
    type: Boolean,
    default: false,
  }
})

</script>

<style lang="scss" scoped>
.headerIcon {
  width: 24px;
  height: 24px;
  position: relative;

  &.warning:after {
    content: "";
    position: absolute;
    width: 14px;
    height: 13px;
    background-image: url("@/assets/icons/_images/14_redWarning.svg");
    top: -4px;
    right: -4px;
  }
}

.innerIcon {
  position: absolute;
  background: rgba(0, 0, 0, 0);
  width: 48px;
  height: 48px;
  left: -12px;
  top: -12px;
  padding: 10px;
  border: 2px solid rgba(231, 94, 94, 0);
  border-radius: 12px;
  box-shadow: 0 0 16px 0 rgba(231, 94, 94, 0);
  transition: all 1s linear;

  &.active {
    background: var(--app-accent-light-color);
    width: 48px;
    height: 48px;
    left: -12px;
    top: -24px;
    padding: 10px;
    border: 2px solid rgba(231, 94, 94, 0.24);
    border-radius: 12px;
    box-shadow: 0 0 8px 0 rgba(231, 94, 94, 0.3);
  }
}

.warning-icon {
  position: absolute;
  background: var(--text-error-color);
  height: 15px;
  min-width: 15px;
  top: 5px;
  right: 5px;
  padding: 1px 4px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  color: var(--text-primary-color);
}

</style>
